import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, ProfileResolver } from '@scientificnet/cockpit-core';

// proper way to avoid problems with
export function homeModule() {
  return import('./home/home.module').then((m) => m.HomeModule);
}

// proper way to avoid problems with
export function appMenuModule() {
  return import('./app-menu/app-menu.module').then((m) => m.AppMenuModule);
}

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: { profile: ProfileResolver },
    loadChildren: homeModule,
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    resolve: { profile: ProfileResolver },
    loadChildren: homeModule,
  },
  {
    path: 'menu',
    canActivate: [AuthGuard],
    resolve: { profile: ProfileResolver },
    loadChildren: appMenuModule,
  },
];

@NgModule({
  // imports: [RouterModule.forChild(routes, { useHash: true })],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
